import { useState } from 'react';
import { TrendUp, CaretDown, CaretUp, ChatCircle } from '@phosphor-icons/react';
import type { TrendingTheme } from '@researcher/shared';

interface CommunityInsightsCardProps {
  trendingThemes: TrendingTheme[];
  commonQuestions?: string[];
  loading?: boolean;
}

export default function CommunityInsightsCard({ trendingThemes, commonQuestions, loading }: CommunityInsightsCardProps) {
  const [expanded, setExpanded] = useState(false);

  if (loading || trendingThemes.length === 0) return null;

  return (
    <div className="bg-gradient-to-r from-orange-50 to-pink-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-orange-200 dark:border-orange-800 p-4 mb-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <TrendUp size={16} className="text-orange-500" weight="bold" />
          <span className="text-sm font-semibold text-gray-700 dark:text-gray-300">Trending</span>
        </div>
        {commonQuestions && commonQuestions.length > 0 && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 flex items-center gap-1 transition-colors"
          >
            {expanded ? 'Less' : 'Common questions'}
            {expanded ? <CaretUp size={12} /> : <CaretDown size={12} />}
          </button>
        )}
      </div>

      <div className="flex flex-wrap gap-2">
        {trendingThemes.map((theme, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-orange-200 dark:border-orange-800"
          >
            {theme.theme}
            <span className="text-gray-400 dark:text-gray-500 text-[10px]">{theme.postCount}</span>
          </span>
        ))}
      </div>

      {expanded && commonQuestions && commonQuestions.length > 0 && (
        <div className="mt-3 pt-3 border-t border-orange-200 dark:border-orange-800 space-y-2">
          {commonQuestions.map((q, i) => (
            <div key={i} className="flex items-start gap-2">
              <ChatCircle size={14} className="text-pink-400 mt-0.5 flex-shrink-0" />
              <span className="text-xs text-gray-600 dark:text-gray-400">{q}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
